import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EstadoOnboardingPainel, OnboardingPainelService} from '../onboarding-painel.service';
import {OnbFocoService} from '../apoio/onb-foco.service';
import {FAIXAS_DE_FATURAMENTO, TIPOS_DE_COMIDA} from '../../../../server/lib/onboarding/PerfilDoNegocioOnboarding';

/**
 * "Conhecendo seu negócio" (docs/plano-perfil-do-negocio-onboarding-v1.md): antes dos passos, uma vez, tipo de comida
 * principal e faixa de faturamento do delivery. Obrigatório; o tipo vem pré-marcado pelo que a Mia anotou na conversa.
 */
@Component({
  selector: 'app-onb-perfil',
  templateUrl: './onb-perfil.component.html',
  styleUrls: ['./onb-perfil.component.scss']
})
export class OnbPerfilComponent implements OnInit {
  @Input() estado: EstadoOnboardingPainel;
  @Output() concluido = new EventEmitter<EstadoOnboardingPainel>();

  readonly tipos = TIPOS_DE_COMIDA;
  readonly faixas = FAIXAS_DE_FATURAMENTO;
  tipo: string | null = null;
  outro = '';
  faixa: string | null = null;
  salvando = false;
  erro = '';

  constructor(private onboarding: OnboardingPainelService, private foco: OnbFocoService) {}

  ngOnInit(): void {
    const perfil = this.estado?.perfil;
    this.tipo = perfil?.tipoComida || perfil?.sugestao || null;
    this.outro = perfil?.tipoComidaOutro || '';
    this.faixa = perfil?.faixaFaturamento || null;
  }

  escolhaTipo(id: string): void {
    this.tipo = id;
    if (id === 'OUTRO') setTimeout(() => document.getElementById('onb-perfil-outro')?.focus(), 0);
  }

  salve(): void {
    if (this.salvando) return;
    if (!this.tipo) return this.foco.mostre('onb-perfil-tipo', 'Escolha o tipo de comida principal da sua loja.');
    if (this.tipo === 'OUTRO' && this.outro.trim().length < 2) return this.foco.mostre('onb-perfil-outro', 'Conte qual é o tipo de comida.');
    if (!this.faixa) return this.foco.mostre('onb-perfil-faixa', 'Escolha quanto seu delivery vendeu no mês passado.');
    this.salvando = true;
    this.erro = '';
    this.onboarding.salvePerfil({tipoComida: this.tipo, tipoComidaOutro: this.tipo === 'OUTRO' ? this.outro.trim() : null, faixaFaturamento: this.faixa})
      .then(estado => this.concluido.emit(estado))
      .catch(e => this.erro = OnboardingPainelService.mensagem(e))
      .finally(() => this.salvando = false);
  }
}
